<template>
  <div class="p-message-edit">
    <div class="c-title">
      <div class="c-title__text u-fs24">配信されるメッセージ内容を作成する</div>
    </div>
    <div class="p-message-edit-list">
      <div class="p-message-edit-list__item">
        <div class="c-input">
          <div class="c-input__title">
            <span class="c-input__text c-input__text--required">【必須】</span>遷移先のURLを設定する
            <span class="c-upload__btn" style="background: #fff; cursor: pointer; margin-bottom: 20px; font-weight:normal; margin-bottom:none" @click="addUtmPrameter">
              UTMパラメータ追加
            </span>
          </div>
          <input
            v-model="clickUrl"
            class="c-input__item"
            type="text"
            name="redirect_url"
            value=""
            placeholder="例）https://webpush.jp/"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title">通知アイコンを設定する</div>
          <label class="c-upload__label">
            <div class="c-upload__image">
              <img v-if="iconUrl" :src="iconUrl" />
              <div v-else class="c-upload__noimage">
                <div class="c-icon c-icon--gray-3 u-wh30">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <use xlink:href="/assets/img/sprite.svg#photo" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="c-upload__data">
              <input
                ref="iconInput"
                type="file"
                name="message_icon"
                value=""
                placeholder="ファイルの選択"
                @change="selectIconFile"
              />
              <span class="c-upload__btn">ファイルの選択</span>
              <div class="c-upload__filename"></div>
              <div class="c-upload__text c-upload__text--spec">
                サイズ：縦64x横64px～縦192x横192px<br />
                容量：5KB以内奨励(最大8KB)<br />
                形式：PNG奨励(JPG可)
              </div>
            </div>
          </label>
          <input type="hidden" name="message_icon_attachement_data" value="" />
          <div
            class="c-error"
            :class="{ 'is-active': errors.messageIcon !== '' }"
          >
            <div class="c-error__text">{{ errors.messageIcon }}</div>
          </div>
        </div>
      </div>

      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title">追加大型画像を設定する</div>
          <div style="position: relative;">
            <label class="c-upload__label">
              <div class="c-upload__image">
                <img v-if="largeImageUrl" id="largeImageUrl" :src="largeImageUrl" />
                <div v-else class="c-upload__noimage">
                  <div class="c-icon c-icon--gray-3 u-wh30">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <use xlink:href="/assets/img/sprite.svg#photo" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="c-upload__data">
                <input
                  ref="largeImageInput"
                  type="file"
                  name="message_big_img"
                  value=""
                  placeholder="ファイルの選択"
                  @change="selectLargeImageFile"
                />
                <span class="c-upload__btn">ファイルの選択</span>
                <div class="c-upload__filename"></div>
                <div class="c-upload__text c-upload__text--spec">
                  サイズ：縦240x横480px<br />
                  容量：128KB以内奨励<br />
                  形式：PNG奨励(JPG可)<br />
                </div>
              </div>
              <span v-show="isDeprecatedSize" style="margin-top: 16px;">※設定画像サイズは非推奨です。端末によって表示が異なる可能性があります</span>
            </label>
            <span
              id="clearLargeImageButton"
              class="c-upload__btn"
              style="position: absolute; top: 28px; left: 270px; cursor: pointer;"
              @click="clearLargeImageFile"
            >クリア</span>
          </div>
          <input type="hidden" name="message_big_img_attachement_data" value="" />
          <div class="c-error" :class="{ 'is-active': errors.messageLargeImage !== '' }">
            <div class="c-error__text">{{ errors.messageLargeImage }}</div>
          </div>
        </div>
      </div>

      <div class="p-message-edit-list__item">
        <div class="c-upload">
          <div class="c-upload__title" style="width: auto;">ステータスアイコンを設定する</div>
          <div style="position: relative;">
            <label class="c-upload__label">
              <div class="c-upload__image">
                <img v-if="badgeUrl" :src="badgeUrl" class="uploaded_transparent_image" />
                <div v-else class="c-upload__noimage">
                  <div class="c-icon c-icon--gray-3 u-wh30">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <use xlink:href="/assets/img/sprite.svg#photo" />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="c-upload__data">
                <input
                  ref="badgeInput"
                  type="file"
                  name="message_badge"
                  value=""
                  placeholder="ファイルの選択"
                  @change="selectBadgeFile"
                />
                <span class="c-upload__btn">ファイルの選択</span>
                <div class="c-upload__filename"></div>
                <div class="c-upload__text c-upload__text--spec">
                  サイズ：縦72x横72px～縦128x横128px<br />
                  5KB以内奨励(最大8KB)<br />
                  形式：PNG<br />
                </div>
              </div>
            </label>
            <span class="c-upload__btn" style="position: absolute; top: 28px; left: 270px; cursor: pointer;" @click="clearBadgeFile">クリア</span>

            <div class="c-help-tooltip">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#question" style="fill: #999; cursor: pointer;" />
              </svg>
              <span class="c-help-tooltip__text">
                <p>メッセージごとにステータスアイコンを設定した場合は優先して適用されます。</p>
                <p>メッセージごとに設定しない場合は、プロジェクト編集のデフォルト設定のステータスアイコンが適用されます。</p>
                <p>どちらも設定していない場合はブラウザやベルのアイコンが適用されます。</p>
              </span>
            </div>

          </div>
          <input type="hidden" name="message_badge_attachement_data" value="" />
          <div class="c-error" :class="{ 'is-active': errors.messageBadge !== '' }">
            <div class="c-error__text">{{ errors.messageBadge }}</div>
          </div>
        </div>
      </div>

      <div class="p-message-edit-list__item">
        <div class="c-input">
          <div class="c-input__title">utmクエリを入力する</div>
          <input
            v-model="utmQuery"
            class="c-input__item"
            type="text"
            name="utm_query"
            placeholder="utmクエリを入力してください"
            @input="onChangeInputText"
          />
          <div class="c-error c-error--balloon">
            <div class="c-error__text"></div>
          </div>
        </div>
      </div>
      <div class="p-message-edit-list-cart__container">
        <div class="p-message-edit-list-cart__title">1回目に配信するメッセージ</div>
        <div class="p-message-edit-list__item">
          <div class="c-input">
            <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>カート追加から何時間後に配信するか入力する</div>
            <input
              v-model="cartWorkHoursFirst"
              class="c-input__item"
              type="text"
              placeholder="半角数字で入力してください"
              name="cart_work_hours_first"
            />
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item">
          <div class="c-input">
            <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する</div>
            <input
              v-model="cartTitleFirst"
              class="c-input__item"
              type="text"
              name="cart_title_first"
              placeholder="メッセージのタイトルを入力してください"
            />
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
        <div class="p-message-edit-list__item">
          <div class="c-textarea">
            <div class="c-textarea__title"><span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する</div>
            <textarea
              v-model="cartMessageFirst"
              class="c-textarea__item"
              name="cart_message_first"
              placeholder="メッセージの本文を入力してください"
            ></textarea>
            <div class="c-error c-error--balloon">
              <div class="c-error__text"></div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="additionalMessageCount >= 1">
        <div class="p-message-edit-list-cart__container">
          <div id="secondMessageRemove" class="p-message-edit-list-cart__remove" @click="removeMessage">
            <div class="c-icon c-icon--gray-3 u-wh16">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#close" />
              </svg>
            </div>
          </div>
          <div class="p-message-edit-list-cart__title">2回目に配信するメッセージ</div>
          <div class="p-message-edit-list__item">
            <div class="c-input">
              <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>カート追加から何時間後に配信するか入力する</div>
              <input
                v-model="cartWorkHoursSecond"
                class="c-input__item"
                type="text"
                placeholder="半角数字で入力してください"
                name="cart_work_hours_second"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list__item">
            <div class="c-input">
              <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する</div>
              <input
                v-model="cartTitleSecond"
                class="c-input__item"
                type="text"
                name="cart_title_second"
                value=""
                placeholder="メッセージのタイトルを入力してください"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list__item">
            <div class="c-textarea">
              <div class="c-textarea__title"><span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する</div>
              <textarea
                v-model="cartMessageSecond"
                class="c-textarea__item"
                name="cart_message_second"
                placeholder="メッセージの本文を入力してください"
              ></textarea>
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="additionalMessageCount === 2">
        <div class="p-message-edit-list-cart__container">
          <div id="thirdMessageRemove" class="p-message-edit-list-cart__remove" @click="removeMessage">
            <div class="c-icon c-icon--gray-3 u-wh16">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <use xlink:href="/assets/img/sprite.svg#close" />
              </svg>
            </div>
          </div>
          <div class="p-message-edit-list-cart__title">3回目に配信するメッセージ</div>
          <div class="p-message-edit-list__item">
            <div class="c-input">
              <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>カート追加から何時間後に配信するか入力する</div>
              <input
                v-model="cartWorkHoursThird"
                class="c-input__item"
                type="text"
                placeholder="半角数字で入力してください"
                name="cart_work_hours_third"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list__item">
            <div class="c-input">
              <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>タイトルを入力する</div>
              <input
                v-model="cartTitleThird"
                class="c-input__item"
                type="text"
                name="cart_title_third"
                value=""
                placeholder="メッセージのタイトルを入力してください"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
          <div class="p-message-edit-list__item">
            <div class="c-textarea">
              <div class="c-textarea__title"><span class="c-input__text c-input__text--required">【必須】</span>メッセージの本文を入力する</div>
              <textarea
                v-model="cartMessageThird"
                class="c-textarea__item"
                name="cart_message_third"
                placeholder="メッセージの本文を入力してください"
              ></textarea>
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="p-message-edit-list__item--add-message">
        <button
          v-show="additionalMessageCount < 2"
          class="c-btn c-btn--blue-dashed u-w100p u-h40 u-fs14"
          type="button"
          value="add_additional_cart_message"
          @click="additionalMessageCount += 1"
        >
          <div class="c-icon-circle c-icon-circle--blue u-wh20">
            <div class="c-icon-circle__item c-icon-circle__item--white u-wh12">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <use xlink:href="/assets/img/sprite.svg#plus" />
              </svg>
            </div>
          </div>
          <p class="c-btn__text">メッセージを追加する</p>
        </button>
      </div>
      <div class="p-message-edit-list__item p-message-edit-list__item--set-cart-non-working-hours">
        <div class="c-select">
          <div class="c-textarea__title">配信しない時間帯を入力する</div>
        </div>
        <select-text
          :value="cartNonWorkingStartHours"
          :classes="['u-w200']"
          place-holder="非稼働開始時間"
          :elements="times"
          :has-blank="true"
          :blank-text="'なし'"
          input-name="cart_non_working_start_hours"
          @select="onInactiveStartHourSelect"
        /> 〜
        <select-text
          :value="cartNonWorkingEndHours"
          :classes="['u-w200']"
          place-holder="非稼働終了時間"
          :elements="times"
          :has-blank="true"
          :blank-text="'なし'"
          input-name="cart_non_working_end_hours"
          @select="onInactiveEndHourSelect"
        />
      </div>

    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Object
  },
  emits: ['update:modelValue', 'optimize-start', 'optimize-end'],
  data: function () {
    return {
      isError: false,
      errorMessage: '',
      errors: {
        messageIcon: '',
        messageLargeImage: ''
      },
      times: {
        '0': '0時',
        '1': '1時',
        '2': '2時',
        '3': '3時',
        '4': '4時',
        '5': '5時',
        '6': '6時',
        '7': '7時',
        '8': '8時',
        '9': '9時',
        '10': '10時',
        '11': '11時',
        '12': '12時',
        '13': '13時',
        '14': '14時',
        '15': '15時',
        '16': '16時',
        '17': '17時',
        '18': '18時',
        '19': '19時',
        '20': '20時',
        '21': '21時',
        '22': '22時',
        '23': '23時',
      },
      additionalMessageCount: 0,
      acceptableMimeTypes: [
        'image/png',
        'image/jpeg',
        'image/gif',
      ],
      timer: null,
      isDeprecatedSize: false,
    };
  },
  computed: {
    clickUrl: {
      get() {
        return this.modelValue.clickUrl;
      },
      set(clickUrl) {
        this.updateValue({
          clickUrl
        });
      }
    },
    iconUrl: {
      get() {
        return this.modelValue.iconUrl;
      },
      set(iconUrl) {
        this.updateValue({
          iconUrl
        });
      }
    },
    selectedIconFile: {
      get() {
        return this.modelValue.selectedIconFile;
      },
      set(selectedIconFile) {
        this.updateValue({
          selectedIconFile
        });
      }
    },
    largeImageUrl: {
      get() {
        return this.modelValue.largeImageUrl;
      },
      set(largeImageUrl) {
        this.updateValue({
          largeImageUrl
        });
      }
    },
    selectedLargeImageFile: {
      get() {
        return this.modelValue.selectedLargeImageFile;
      },
      set(selectedLargeImageFile) {
        this.updateValue({
          selectedLargeImageFile
        });
      }
    },
    badgeUrl: {
      get() {
        return this.modelValue.badgeUrl;
      },
      set(badgeUrl) {
        this.updateValue({
          badgeUrl
        });
      }
    },
    selectedBadgeFile: {
      get() {
        return this.modelValue.selectedBadgeFile;
      },
      set(selectedBadgeFile) {
        this.updateValue({
          selectedBadgeFile
        });
      }
    },
    cartNonWorkingStartHours: {
      get() {
        return this.modelValue.cartNonWorkingStartHours;
      },
      set(cartNonWorkingStartHours) {
        this.updateValue({
          cartNonWorkingStartHours
        });
      }
    },
    cartNonWorkingEndHours: {
      get() {
        return this.modelValue.cartNonWorkingEndHours;
      },
      set(cartNonWorkingEndHours) {
        this.updateValue({
          cartNonWorkingEndHours
        });
      }
    },
    utmQuery: {
      get() {
        return this.modelValue.utmQuery;
      },
      set(utmQuery) {
        this.updateValue({
          utmQuery
        });
      }
    },
    cartWorkHoursFirst: {
      get() {
        return this.modelValue.cartWorkHoursFirst;
      },
      set(cartWorkHoursFirst) {
        this.updateValue({
          cartWorkHoursFirst
        });
      }
    },
    cartTitleFirst: {
      get() {
        return this.modelValue.cartTitleFirst;
      },
      set(cartTitleFirst) {
        this.updateValue({
          cartTitleFirst
        });
      }
    },
    cartMessageFirst: {
      get() {
        return this.modelValue.cartMessageFirst;
      },
      set(cartMessageFirst) {
        this.updateValue({
          cartMessageFirst
        });
      }
    },
    cartWorkHoursSecond: {
      get() {
        return this.modelValue.cartWorkHoursSecond;
      },
      set(cartWorkHoursSecond) {
        this.updateValue({
          cartWorkHoursSecond
        });
      }
    },
    cartTitleSecond: {
      get() {
        return this.modelValue.cartTitleSecond;
      },
      set(cartTitleSecond) {
        this.updateValue({
          cartTitleSecond
        });
      }
    },
    cartMessageSecond: {
      get() {
        return this.modelValue.cartMessageSecond;
      },
      set(cartMessageSecond) {
        this.updateValue({
          cartMessageSecond
        });
      }
    },
    cartWorkHoursThird: {
      get() {
        return this.modelValue.cartWorkHoursThird;
      },
      set(cartWorkHoursThird) {
        this.updateValue({
          cartWorkHoursThird
        });
      }
    },
    cartTitleThird: {
      get() {
        return this.modelValue.cartTitleThird;
      },
      set(cartTitleThird) {
        this.updateValue({
          cartTitleThird
        });
      }
    },
    cartMessageThird: {
      get() {
        return this.modelValue.cartMessageThird;
      },
      set(cartMessageThird) {
        this.updateValue({
          cartMessageThird
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.additionalMessageCount = this.getInitialCount();
    });
  },
  methods: {
    updateValue(target) {
      // 親のv-modelを更新
      this.$emit('update:modelValue', {
        ...this.modelValue,
        ...target
      })
    },
    addUtmPrameter: function () {
      const key1 = 'utm_source';
      const val1 = 'webpush';
      const key2 = 'utm_medium';
      const val2 = 'pushone';

      try {
        const url = new URL(this.clickUrl);
        const searchParams = new URLSearchParams(url.search);
        if (!searchParams.has(key1) && searchParams.get(key1) != val1) {
          searchParams.append(key1, val1);
        }
        if (!searchParams.has(key2) && searchParams.get(key2) != val2) {
          searchParams.append(key2, val2);
        }
        url.search = searchParams.toString();
        this.clickUrl = url.href;

      } catch {
        this.isError = true;
        this.errorMessage = '遷移先のURLが不正です';
        return;
      }
    },
    clearLargeImageFile: function () {
      this.updateValue({ selectedLargeImageFile: null, largeImageUrl: '' });
      this.$refs.largeImageInput.value = '';
    },
    clearBadgeFile: function () {
      this.updateValue({ selectedBadgeFile: null, badgeUrl: '' });
      this.$refs.badgeInput.value = '';
    },
    isAcceptableMimeType: function (mimeType) {
      var isAcceptable = false;
      this.acceptableMimeTypes.forEach(function (acceptableMimeType) {
        if (acceptableMimeType == mimeType) {
          isAcceptable = true;
        }
      });
      return isAcceptable;
    },
    selectIconFile: function () {
      let iconFile = this.$refs.iconInput.files[0];
      if (iconFile.size > 8192) {
        this.isError = true;
        this.errorMessage = '通知アイコンは8KB以下のファイルを指定してください。';
        this.errors.messageIcon = '通知アイコンは8KB以下のファイルを指定してください';
        return;
      }

      if (!this.isAcceptableMimeType(iconFile.type)) {
        this.isError = true;
        this.errorMessage = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        this.errors.messageLargeImage = '通知アイコンはPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      this.errors.messageIcon = '';

      var me = this;
      const reader = new FileReader();
      reader.addEventListener("load", function () {
        me.iconUrl = reader.result;
      }, false);
      reader.readAsDataURL(iconFile);

      this.selectedIconFile = iconFile;
    },
    selectLargeImageFile: function () {
      let largeImageFile = this.$refs.largeImageInput.files[0];
      this.errors.messageLargeImage = '';

      if (!this.isAcceptableMimeType(largeImageFile.type)) {
        this.isError = true;
        this.errorMessage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        this.errors.messageLargeImage = '追加大型画像はPNG/JPEG/GIF形式のファイルを指定してください。';
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      fileReader.onload = () => {
        // アップロードされた画像が128KB以内の場合は圧縮処理を行わない
        if (largeImageFile.size < 131072) {
          self.largeImageUrl = fileReader.result;
          return;
        }
        const offset = fileReader.result.indexOf(",") + 1;
        const base64 = fileReader.result.slice(offset);
        const data = `data:${largeImageFile.type};base64,${base64}`;

        const params = {
          data: data,
          max_size: 480,
          max_bytes: 131072
        }
        self.optimizeImage(params, function(optimizedImage) {
          if (optimizedImage) {
            if (optimizedImage.filesize > 131072) { // 128KB
              self.isError = true;
              self.errorMessage = '追加大型画像は128KB以下のファイルを指定してください。';
              self.errors.messageLargeImage = '追加大型画像は128KB以下のファイルを指定してください。';
              self.$forceUpdate();
              return;
            }
            self.largeImageUrl = optimizedImage.data;
          } else {
            if (largeImageFile.size > 131072) { // 128KB
              self.isError = true;
              self.errorMessage = '追加大型画像は128KB以下のファイルを指定してください。';
              self.errors.messageLargeImage = '追加大型画像は128KB以下のファイルを指定してください。';
              self.$forceUpdate();
              return;
            }
            self.largeImageUrl = fileReader.result;
          }
        });
      };
      fileReader.readAsDataURL(largeImageFile);
      // ABテストの追加大型画像をフォームデータに登録するため
      this.selectedLargeImageFile = largeImageFile;
    },
    selectBadgeFile: function () {
      let badgeFile = this.$refs.badgeInput.files[0];
      this.errors.messageBadge = '';

      if (badgeFile.size > 8192) {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンは8KB以下のファイルを指定してください。';
        this.errors.messageBadge = 'ステータスアイコンは8KB以下のファイルを指定してください';
        return;
      }

      if (badgeFile.type != 'image/png') {
        this.isError = true;
        this.errorMessage = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        this.errors.messageBadge = 'ステータスアイコンはPNG形式のファイルを指定してください。';
        return;
      }

      const fileReader = new FileReader();
      const self = this;

      self.checkImageTransparency(fileReader);
      fileReader.readAsDataURL(badgeFile);

      this.selectedBadgeFile = badgeFile;
    },
    onCartWorkHoursFirstSelect: function (selected) {
      this.cartWorkHoursFirst = selected;
    },
    onCartWorkHoursSecondSelect: function (selected) {
      this.cartWorkHoursSecond = selected;
    },
    onCartWorkHoursThirdSelect: function (selected) {
      this.cartWorkHoursThird = selected;
    },
    onInactiveStartHourSelect: function (selected) {
      this.cartNonWorkingStartHours = selected;
    },
    onInactiveEndHourSelect: function (selected) {
      this.cartNonWorkingEndHours = selected;
    },

    onChangeInputText: function (_event) {

    },
    checkMessageFormat(text) {
      const pattern = /[<>]/g;
      return !pattern.test(text);
    },
    checkLength(text, max) {
      return text.length <= max;
    },
    checkNumberFormat(value) {
      return Number(value) >= 0 && /^[\d]+$/.test(value);
    },
    validate: function (errors) {
      if (!this.clickUrl) {
        errors['redirect_url'] = 'URLを入力してください';
      }

      if (this.cartWorkHoursFirst == null || this.cartWorkHoursFirst == '') {
        errors['cart_work_hours_first'] = 'カート追加から何時間後に配信するか入力してください';
      } else if (!this.checkNumberFormat(this.cartWorkHoursFirst)) {
        errors['cart_work_hours_first'] = '0以上の半角数字で入力してください';
      }

      if (!this.cartTitleFirst) {
        errors['cart_title_first'] = 'タイトルを入力してください';
      } else if (!this.checkMessageFormat(this.cartTitleFirst)) {
        errors['cart_title_first'] = '使用出来ない文字が含まれています';
      } else if (!this.checkLength(this.cartTitleFirst, 140)) {
        errors['cart_title_first'] = 'タイトルは140文字以内で入力してください';
      }

      if (!this.cartMessageFirst) {
        errors['cart_message_first'] = '本文を入力してください';
      } else if (!this.checkMessageFormat(this.cartMessageFirst)) {
        errors['cart_message_first'] = '使用出来ない文字が含まれています';
      } else if (!this.checkLength(this.cartMessageFirst, 1024)) {
        errors['cart_message_first'] = '本文は1024文字以内で入力してください';
      }


      if(this.additionalMessageCount >= 1){
        if (this.cartWorkHoursSecond == null || this.cartWorkHoursSecond == '') {
          errors['cart_work_hours_second'] = 'カート追加から何時間後に配信するか入力してください';
        } else if (!this.checkNumberFormat(this.cartWorkHoursSecond)) {
          errors['cart_work_hours_second'] = '0以上の半角数字で入力してください';
        }

        if (!this.cartTitleSecond) {
          errors['cart_title_second'] = 'タイトルを入力してください';
        } else if (!this.checkMessageFormat(this.cartTitleSecond)) {
          errors['cart_title_second'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.cartTitleSecond, 140)) {
          errors['cart_title_second'] = 'タイトルは140文字以内で入力してください';
        }

        if (!this.cartMessageSecond) {
          errors['cart_message_second'] = '本文を入力してください';
        } else if (!this.checkMessageFormat(this.cartMessageSecond)) {
          errors['cart_message_second'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.cartMessageSecond, 1024)) {
          errors['cart_message_second'] = '本文は1024文字以内で入力してください';
        }
      }

      if(this.additionalMessageCount === 2){
        if (this.cartWorkHoursThird == null || this.cartWorkHoursThird == '') {
          errors['cart_work_hours_third'] = 'カート追加から何時間後に配信するか入力してください';
        } else if (!this.checkNumberFormat(this.cartWorkHoursThird)) {
          errors['cart_work_hours_third'] = '0以上の半角数字で入力してください';
        }

        if (!this.cartTitleThird) {
          errors['cart_title_third'] = 'タイトルを入力してください';
        } else if (!this.checkMessageFormat(this.cartTitleThird)) {
          errors['cart_title_third'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.cartTitleThird, 140)) {
          errors['cart_title_third'] = 'タイトルは140文字以内で入力してください';
        }

        if (!this.cartMessageThird) {
          errors['cart_message_third'] = '本文を入力してください';
        } else if (!this.checkMessageFormat(this.cartMessageThird)) {
          errors['cart_message_third'] = '使用出来ない文字が含まれています';
        } else if (!this.checkLength(this.cartMessageThird, 1024)) {
          errors['cart_message_third'] = '本文は1024文字以内で入力してください';
        }
      }

      if (
        (this.cartNonWorkingStartHours == null &&
          this.cartNonWorkingEndHours != null) ||
        (this.cartNonWorkingStartHours != null &&
          this.cartNonWorkingEndHours == null)
      ) {
        errors['cart_non_working_start_hours'] = '片方のみの入力はできません';
        errors['cart_non_working_end_hours'] = '片方のみの入力はできません';
      }
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    hasSecondMessage() {
      return (
        this.modelValue.cartWorkHoursSecond != null ||
        this.modelValue.cartTitleSecond ||
        this.modelValue.cartMessageSecond
      );
    },
    hasThirdMessage() {
      return (
        this.modelValue.cartWorkHoursThird != null ||
        this.modelValue.cartTitleThird ||
        this.modelValue.cartMessageThird
      );
    },
    getInitialCount() {
      return this.hasSecondMessage() && this.hasThirdMessage()
        ? 2
        : this.hasSecondMessage() || this.hasThirdMessage()
          ? 1
          : 0;
    },
    removeMessage(e) {
      const changes = { cartWorkHoursThird: '', cartTitleThird: '', cartMessageThird: '' };
      if (e.target.id === 'secondMessageRemove') {
        changes.cartWorkHoursSecond = this.modelValue.cartWorkHoursThird;
        changes.cartTitleSecond = this.modelValue.cartTitleThird;
        changes.cartMessageSecond = this.modelValue.cartMessageThird;
      }
      this.updateValue(changes);
      this.additionalMessageCount -= 1;
    },
    optimizeImage: function(params, callback) {
      const endpoint = 'https://bpjflajowoc3zds6vfdqnhcfs40irvbj.lambda-url.ap-northeast-1.on.aws';
      this.$emit('optimize-start');
      axios.post(endpoint, params)
        .then(res => {
          callback(res.data);
        })
        .catch(_e => {
          callback(null);
        })
        .finally(() => {
          this.$emit("optimize-end");
        });
    },
    checkImageTransparency: function(fileReader) {
      fileReader.onload = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const alphaChannel = imageData.data.filter((_, i) => (i + 1) % 4 === 0)
          if (alphaChannel.some(alpha => alpha !== 255)) {
            this.badgeUrl = fileReader.result;
          } else {
            this.isError = true;
            this.errorMessage = 'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
            this.errors.messageBadge = 'ステータスアイコンは透過されたPNG形式のファイルを指定してください。';
          }
        }
        img.src = fileReader.result;
      };
    },
  },
}
</script>

<style scoped>
.uploaded_transparent_image {
    margin: 0;
    padding: 0;
    background-color: #fff;
    background-image: linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd),
    linear-gradient(45deg, #ddd 25%, transparent 25%, transparent 75%, #ddd 75%, #ddd);
    background-size: 18px 18px;
    background-position: 0 0, 9px 9px;
    overflow: hidden;
}

.c-help-tooltip {
    position: relative;
    top: -115px;
    left: 360px;
    width: 20px;
}

.c-help-tooltip > svg {
    height: 20px;
    width: 20px;
}

.c-help-tooltip__text {
    position: absolute;
    width: 700px;
    top: 33px;
    left: -240px;
    visibility: hidden;
    opacity: 0;
    transition: 0.5s all;
    /* border: solid 1px #999; */
    background: #eef8f8;
    border-radius: 5px;
    padding: 10px;
    font-size: small;
    box-shadow: -1px 4px 0px #eef8f8, 0px 0px 10px #ccc, 1px 5px 5px #aaa;
    z-index: 1000;
}

.c-help-tooltip:hover .c-help-tooltip__text {
  visibility: visible;
  opacity: 1;
}
</style>
